// extracted by mini-css-extract-plugin
export default {"new_project_container":"style_new_project_container__h+R7d"};